export class EmailSubscriptionFormComponent extends HTMLElement {
  static host = SCATTERGUN_URL

  constructor() {
    super()
    this.virtualForm = new VirtualForm()
  }

  connectedCallback() {
    this.render()
  }

  async render() {
    let response = await fetch(this.formPath)
    if (response.status != 200) { return }

    this.virtualForm.content = await response.text()

    if (this.type == "styled") {
      this.attachShadow({ mode: "open" });
      this.shadowRoot.innerHTML = this.virtualForm.render()
    } else {
      this.renderLightDom()
    }
  }

  renderLightDom() {
    if (this.customFormFields) {
      this.virtualForm.fields = this.customFormFields.innerHTML
    }

    this.innerHTML = this.virtualForm.render()
  }

  get formPath() {
    return `${this.constructor.host}/public/mailing_lists/${this.publishableKey}/subscribe?component=${this.type}`
  }

  get publishableKey() {
    return this.getAttribute("publishable-key")
  }

  get type() {
    return this.getAttribute("type") || "unstyled"
  }

  get customFormFields() {
    return this.querySelector("template")
  }
}

class VirtualForm {
  constructor() {
    this.root = document.createElement("div")
  }

  get fields() {
    return this.root.querySelector("template")
  }

  set fields(newFields) {
    this.root.querySelector("template").innerHTML = newFields
  }

  get content() {
    return this.root.innerHTML
  }

  set content(newContent) {
    this.root.innerHTML = newContent
  }

  get form() {
    return this.root.querySelector("form")
  }

  render() {
    if (this.fields) {
      this.form.append(this.fields.content.cloneNode(true))
      this.fields.remove()
    }

    return this.content
  }
}